const o = {
  primary: {
    backgroundColor: "button-primary-bg_hover",
    borderColor: "button-primary-bg_hover"
  },
  secondary: {
    boxShadow: "shadow-3",
    backdropFilter: "blur(20px)"
  },
  tertiary: {
    boxShadow: "shadow-3",
    backdropFilter: "blur(20px)"
  }
}, r = {
  primary: {
    backgroundColor: "button-primary-bg_subtle",
    borderColor: "button-primary-bg_subtle"
  },
  secondary: {
    boxShadow: "none",
    backdropFilter: "blur(2px)"
  },
  tertiary: {
    boxShadow: "none",
    backdropFilter: "blur(2px)"
  }
}, b = {
  primary: {
    color: "fg-disabled",
    backgroundColor: "bg-disabled",
    borderColor: "border-disabled"
  },
  secondary: {
    color: "fg-disabled",
    backgroundColor: "bg-disabled_subtle",
    borderColor: "border-disabled_sublte",
    boxShadow: "none",
    backdropFilter: "none"
  },
  tertiary: {
    color: "fg-disabled",
    backgroundColor: "bg-disabled_subtle",
    borderColor: "border-disabled_sublte",
    boxShadow: "none",
    backdropFilter: "none"
  }
};
export {
  r as active,
  b as disabled,
  o as hover
};
